import Vue from 'vue'
import Router from 'vue-router'

/**
 * 斐燃生活模块
 */
// 主题
import index from '@/components/index/index'
import my from '@/components/my/my'



import reserve from '@/components/reserve/reserve'
import vip from '@/components/vip/vip'
// 分支
import discountlist from '@/components/discount/activity/list'
import activate_single from '@/components/activate/activate_single'
import activate_groupe from '@/components/activate/activate_group'
import login from '@/components/login/login'
import protocol from '@/components/protocol/protocol'
import privacy from '@/components/protocol/privacy'
import myCard from '@/components/myCard/myCard'
import myCardDetail from '@/components/myCard/myCardDetail'
import orderlist from '@/components/order/list'
import orderdetail from '@/components/order/detail'
import mycoupon from '@/components/coupon/mycoupon'
import sharecoupon from '@/components/sharecoupon/sharecoupon'
import couponrule from '@/components/coupon/couponrule'
import about from '@/components/about/about'
import resdetail from '@/components/reserve/resdetail'
import realname from '@/components/realname/realname'
import createorder from '@/components/createorder/createorder'
import createordernocard from '@/components/createorder/createorderNoCard'
import vipsuccess from '@/components/vip/vipsuccess'
import activatesuccess from '@/components/activate/activatesuccess'
import vipbenefit from '@/components/vip/vipBenefit'
import brand from '@/components/brand/brand'
import resdetailbrand from '@/components/reserve/resdetailBrand'
import buycardprotocol from '@/components/protocol/buyCardProtocol'
// import buyCardProtocolB from '@/components/protocol/buyCardProtocolB'
import feedback from '@/components/feedback/feedback'
import freebenefittime from '@/components/vip/freeBenefitTime'
import useRules from '@/components/protocol/useRules'
import allstadium from '@/components/vip/allstadium'
import allstadiumslists from '@/components/vip/allstadiumslists'
import frstadiumslists from '@/components/vip/frstadiumslists'
import frstadiumslistswx from '@/components/vip/frstadiumslistswx'

import frregionstadiumlists from '@/components/vip/frregionstadiumlists'

import companystadiums from '@/components/vip/companystadium'
import guidapplet from '@/components/guidapplet/guidapplet'
// 授权
import author from '@/components/author'
// 活动
import buycardgetcoupon from '@/components/activity/buyCardGetCoupon/buyCardGetCoupon'//买卡送优惠券
import hotsell from '@/components/activity/limitedTime/hotsell'//秒杀活动
import hotsellcreate from '@/components/activity/limitedTime/hotsellcreate'//秒杀活动
import welcome from '@/components/activity/welcome/welcome'//秒杀活动
import acfour from '@/components/activity/acfour/acfour'//斐燃4月活动
import supercoupon from '@/components/activity/supercoupon/supercoupon'//斐燃长期活动
// 非对外链接
import te from '@/components/unpublic/agent/te'
import fragent from '@/components/unpublic/agent/fragent'
import fragentCreateOrder from '@/components/unpublic/agent/fragentCreateOrder'
import fxbuylist from '@/components/unpublic/fxbuycode/fxbuylist'
import fxbuysuccess from '@/components/unpublic/fxbuycode/fxbuysuccess'
import activelist from '@/components/unpublic/fxbuycode/activelist'
import activedetail from '@/components/unpublic/fxbuycode/activedetail'
import deleteopid from '@/components/unpublic/fxbuycode/deleteopid'
// 小程序活动链接
import wxactivitytest from '@/components/wxactivity/testactivity/test'
// 生成二维码
import wxqrcode from '@/components/qrcode/qrcode'
//斐燃买卡赠送小熊饭盒
import lunchbox from '@/components/activity/buycardgift/lunchbox'

/**
 * 小程序分销模块
 */
import fxindex from '@/fxviews/fxindex/fxindex'//斐燃分销首页
import fxmyinvite from '@/fxviews/fxmyinvite/fxmyinvite'//斐燃分销邀请记录
import fxwallet from '@/fxviews/fxwallet/fxwallet'//斐燃分销我的钱包

import protolsecret from '@/components/mypri/protolsecret'
import protoluser from '@/components/mypri/protoluser'

import downloadapp from '@/components/download/download'
import appprivacy from '@/components/protocol/appprivacy'

import frregressiongift from '@/components/ac/acRegressionGift'

import frmonthcard from '@/components/monthcard/monthcard'
import frdiamondscard from '@/components/monthcard/diamonds'

/*
微信小程序分身开始
*/
import wxseparationprotolsecret from '@/wxseparation/wxprotolsecret'
import wxseparationprotolsecrets from '@/wxseparation/wxprotolsecrets'
import wxseparationwxprotoluser from '@/wxseparation/wxprotoluser'
import wxseparationwxprotolusers from '@/wxseparation/wxprotolusers'
import wxseparationwxvipopenrule from '@/wxseparation/wxvipopenrule'
import wxseparationwxvipopenrules from '@/wxseparation/wxvipopenrules'
import wxseparationwxviprule from '@/wxseparation/wxviprule'
import wxseparationwxviprules from '@/wxseparation/wxviprules'
/*
微信小程序分身结束
*/
import towxtoindex from '@/components/aa_toWx/toindex'
import towxtocoupons from '@/components/aa_toWx/tocoupons'
import towxtoarticle from '@/components/aa_toWx/toarticle'
import towxto1111ac from '@/components/aa_toWx/to1111ac'
import towxtorechage from '@/components/aa_toWx/torechage'
import toenterpriseWeixin from '@/components/aa_toWx/toenterpriseWeixin'
import tomycoupon from '@/components/aa_toWx/tomycoupon'
import tocouponsDiamond from '@/components/aa_toWx/tocouponsDiamond'
import to618active1 from '@/components/aa_toWx/to618active1'
import toindexsource from '@/components/aa_toWx/toindexsource'
import toactivation from '@/components/aa_toWx/toactivation'
import hyrox from '@/components/hyrox/hyrox'

// 瑜伽模块
// import yogain_trainee from '@/yogain/trainee'
// import yogain_invite from '@/yogain/Invite'
// import yogain_home from '@/yogain/Home'

Vue.use(Router)
const router =  new Router({
  mode: 'history',
  routes: [
	
    {
      path: '/te',
      name: 'te',
      component: te,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    {
      path: '/to618active1',
      name: 'to618active1',
      component: to618active1,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    {
      path: '/toenterpriseWeixin',
      name: 'toenterpriseWeixin',
      component: toenterpriseWeixin,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    {
      path: '/',
      name: 'towxtoindex',
      component: towxtoindex,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    {
      path: '/towxto1111ac',
      name: 'towxto1111ac',
      component: towxto1111ac,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    {
      path: '/tomycoupon',
      name: 'tomycoupon',
      component: tomycoupon,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    {
      path: '/tocouponsDiamond',
      name: 'tocouponsDiamond',
      component: tocouponsDiamond,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    {
      path: '/towxtorechage',
      name: 'towxtorechage',
      component: towxtorechage,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    {
      path: '/towxtocoupons',
      name: 'towxtocoupons',
      component: towxtocoupons,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/toactivation',
      name: 'toactivation',
      component: toactivation,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/towxtoarticle',
      name: 'towxtoarticle',
      component: towxtoarticle,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    // 微信小程序 月卡
    {
      path: '/frmonthcard',
      name: 'frmonthcard',
      component: frmonthcard,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/frdiamondscard',
      name: 'frdiamondscard',
      component: frdiamondscard,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    // 引导
    {
      path: '/guidapplet',
      name: 'guidapplet',
      component: guidapplet,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },

    // 微信小程序 月卡
    {
      path: '/frmonthcard',
      name: 'frmonthcard',
      component: frmonthcard,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    // 微信小程序 回归好礼
    {
      path: '/frregressiongift',
      name: 'frregressiongift',
      component: frregressiongift,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    // app下载
    {
      path: '/downloadapp',
      name: 'downloadapp',
      component: downloadapp,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/appprivacy',
      name: 'appprivacy',
      component: appprivacy,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
       path: '/login',
       name: 'login',
       component: login,
       meta: {
         keepAlive: false,
         requireAuth: false
       }
    },{
       path: '/hyrox',
       name: 'hyrox',
       component: hyrox,
       meta: {
         keepAlive: false,
         requireAuth: false
       }
    },{
       path: '/protolsecret',
       name: 'protolsecret',
       component: protolsecret,
       meta: {
         keepAlive: false,
         requireAuth: false
       }
    },{
       path: '/protoluser',
       name: 'protoluser',
       component: protoluser,
       meta: {
         keepAlive: false,
         requireAuth: false
       }
    },

    // {
    //    path: '/yogain_trainee',//-:sthei-:hei
    //    name: 'yogain_trainee',
    //    component: yogain_trainee,
    //    meta: {
    //      keepAlive: false,
    //      requireAuth: false
    //    }
    // },{
    //    path: '/yogain_invite',//-:sthei-:hei
    //    name: 'yogain_invite',
    //    component: yogain_invite,
    //    meta: {
    //      keepAlive: false,
    //      requireAuth: false
    //    }
    // },{
    //    path: '/yogain_home',//-:sthei-:hei
    //    name: 'yogain_home',
    //    component: yogain_home,
    //    meta: {
    //      keepAlive: false,
    //      requireAuth: false
    //    }
    // },


    // {
    //   path: '/guidapplet',
    //   name: 'guidapplet',
    //   component: guidapplet,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },
    // 分销
    {
      path: '/fxindex',
      name: 'fxindex',
      component: fxindex,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/fxmyinvite',
      name: 'fxmyinvite',
      component: fxmyinvite,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/fxwallet',
      name: 'fxwallet',
      component: fxwallet,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },

    // 授权
    {
      path: '/author',
      name: 'author',
      component: author,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/allstadiumslists-:type',
      name: 'allstadiumslists',
      component: allstadiumslists,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/frstadiumslists-:type',
      name: 'frstadiumslists',
      component: frstadiumslists,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/frstadiumslistswx-:type-:vname-:showblack-:cards_id',
      name: 'frstadiumslistswx',
      component: frstadiumslistswx,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/frregionstadiumlists-:region-:type-:cards_id',
      name: 'frregionstadiumlists',
      component: frregionstadiumlists,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/companystadiums',
      name: 'companystadiums',
      component: companystadiums,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/wxqrcode-:qrcode',
      name: 'wxqrcode',
      component: wxqrcode,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    // 小熊午餐饭盒
    {
      path: '/lunchbox',
      name: 'lunchbox',
      component: lunchbox,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    // 非对外链接
    {
      path: '/fragent',
      name: 'fragent',
      component: fragent,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },{
      path: '/fragentCreateOrder',
      name: 'fragentCreateOrder',
      component: fragentCreateOrder,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: '/fxbuylist',
      name: 'fxbuylist',
      component: fxbuylist,
      meta: {
        keepAlive: true,
        requireAuth: true
      }
    },
    {
      path: '/fxbuysuccess-:order_no',
      name: 'fxbuysuccess',
      component: fxbuysuccess,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },{
      path: '/activelist',
      name: 'activelist',
      component: activelist,
      meta: {
        keepAlive: true,
        requireAuth: true
      }
    },{
      path: '/activedetail-:order_no',
      name: 'activedetail',
      component: activedetail,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    ,{
      path: '/deleteopid',
      name: 'deleteopid',
      component: deleteopid,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },
    // 小程序活动地址
    {
      path: '/wxactivity/test-:status-:token',
      name: 'wxactivitytest',
      component: wxactivitytest,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },


    /*
    微信小程序分身开始
    */

    {
      path: '/wxseparationprotolsecret',// 微信分身：用户隐私政策
      name: 'wxseparationprotolsecret',
      component: wxseparationprotolsecret,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/wxseparationprotolsecrets',// 微信分身：用户隐私政策
      name: 'wxseparationprotolsecrets',
      component: wxseparationprotolsecrets,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/wxseparationwxprotoluser',// 微信分身：用户协议
      name: 'wxseparationwxprotoluser',
      component: wxseparationwxprotoluser,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/wxseparationwxprotolusers',// 微信分身：用户协议
      name: 'wxseparationwxprotolusers',
      component: wxseparationwxprotolusers,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/wxseparationwxvipopenrule',// 微信分身：斐燃会员开通协议
      name: 'wxseparationwxvipopenrule',
      component: wxseparationwxvipopenrule,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/wxseparationwxvipopenrules',// 微信分身：斐燃会员开通协议
      name: 'wxseparationwxvipopenrules',
      component: wxseparationwxvipopenrules,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/wxseparationwxviprule',// 微信分身：斐燃会员使用规则
      name: 'wxseparationwxviprule',
      component: wxseparationwxviprule,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },{
      path: '/wxseparationwxviprules',// 微信分身：斐燃会员使用规则
      name: 'wxseparationwxviprules',
      component: wxseparationwxviprules,
      meta: {
        keepAlive: false,
        requireAuth: false
      }
    },

    /*
    微信小程序分身结束
    */



    //
    /**
    // 主题
    // {
    //   path: '/',
    //   name: 'index',
    //   component: index,
    //   meta: {
    //     keepAlive: true,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/my',
    //   name: 'my',
    //   component: my,
    //   meta: {
    //     keepAlive: true,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/reserve',
    //   name: 'reserve',
    //   component: reserve,
    //   meta: {
    //     keepAlive: true,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/vip',
    //   name: 'vip',
    //   component: vip,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },
    // {
    //   path: '/protocol',
    //   name: 'protocol',
    //   component: protocol,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: false
    //   }
    // },

    // 分支
    // {
    //   path: '/discountlist',
    //   name: 'discountlist',
    //   component: discountlist,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/activate_single',
    //   name: 'activate_single',
    //   component: activate_single,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/activate_groupe',
    //   name: 'activate_groupe',
    //   component: activate_groupe,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },
    // {
    // //   path: '/login',
    // //   name: 'login',
    // //   component: login,
    // //   meta: {
    // //     keepAlive: false,
    // //     requireAuth: false
    // //   }
    // // },
    {
    //   path: '/protocol',
    //   name: 'protocol',
    //   component: protocol,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: false
    //   }
    // },{
    //   path: '/privacy',
    //   name: 'privacy',
    //   component: privacy,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: false
    //   }
    // },{
    //   path: '/myCard',
    //   name: 'myCard',
    //   component: myCard,
    //   meta: {
    //     keepAlive: true,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/myCardDetail-:id',
    //   name: 'myCardDetail',
    //   component: myCardDetail,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/orderlist',
    //   name: 'orderlist',
    //   component: orderlist,
    //   meta: {
    //     keepAlive: true,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/orderdetail-:order_no-:book_type',
    //   name: 'orderdetail',
    //   component: orderdetail,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/mycoupon',
    //   name: 'mycoupon',
    //   component: mycoupon,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/couponrule',
    //   name: 'couponrule',
    //   component: couponrule,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/about',
    //   name: 'about',
    //   component: about,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/resdetail-:stadium_id',
    //   name: 'resdetail',
    //   component: resdetail,
    //   meta: {
    //     keepAlive: true,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/realname-:initialswipe',
    //   name: 'realname',
    //   component: realname,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/createorder',
    //   name: 'createorder',
    //   component: createorder,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/createordernocard',
    //   name: 'createordernocard',
    //   component: createordernocard,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/vipsuccess-:order_no',
    //   name: 'vipsuccess',
    //   component: vipsuccess,
    //   meta: {
    //     keepAlive: true,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/activatesuccess-:user_cards_id',
    //   name: 'activatesuccess',
    //   component: activatesuccess,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/vipbenefit-:type-:card_no-:active-:disc-:stype',
    //   name: 'vipbenefit',
    //   component: vipbenefit,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/brand-:stadium_brand_id',
    //   name: 'brand',
    //   component: brand,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/resdetailbrand-:stadium_id-:index-:stadium_brand_id',
    //   name: 'resdetailbrand',
    //   component: resdetailbrand,
    //   meta: {
    //     keepAlive: true,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/buycardprotocol',
    //   name: 'buycardprotocol',
    //   component: buycardprotocol,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/sharecoupon',
    //   name: 'sharecoupon',
    //   component: sharecoupon,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/feedback',
    //   name: 'feedback',
    //   component: feedback,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/freebenefittime-:cards_no-:free_times',
    //   name: 'freebenefittime',
    //   component: freebenefittime,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/useRules',
    //   name: 'useRules',
    //   component: useRules,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: false
    //   }
    // },{
    //   path: '/allstadium-:type',
    //   name: 'allstadium',
    //   component: allstadium,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: false
    //   }
    // },
    // 活动
    // {
    //   path: '/buycardgetcoupon',
    //   name: 'buycardgetcoupon',
    //   component: buycardgetcoupon,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/hotsell',
    //   name: 'hotsell',
    //   component: hotsell,
    //   meta: {
    //     keepAlive: true,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/hotsellcreate',
    //   name: 'hotsellcreate',
    //   component: hotsellcreate,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/welcome',
    //   name: 'welcome',
    //   component: welcome,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/acfour',
    //   name: 'acfour',
    //   component: acfour,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },{
    //   path: '/supercoupon',
    //   name: 'supercoupon',
    //   component: supercoupon,
    //   meta: {
    //     keepAlive: false,
    //     requireAuth: true
    //   }
    // },
    */
  ]
})

const baseurl = encodeURI((window.location.href).split('.cn')[0])+'.cn'//"http://test.official.unionfit.cn"; //本地测试地址
// const baseurl = "http://official.unionfit.cn";//正式地址
// const baseurl = "http://pre-release.official.unionfit.cn";//预发布

// 请求微信服务器获取code 方法
function getUserCode() {
  let redirectURL = encodeURI((baseurl + "/author").split('&code')[0]); //获取地址
  const base = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=';
  let state;
  let surl;
  let reserveUrl;
  let appid = "wx1c24d0b2f06df7f9";
  let scope = "snsapi_userinfo";
  window.location.href="https://api.unionfit.cn/wx/wechat/authorize?callback_url="+redirectURL+"&scope=snsapi_userinfo"
}
router.beforeEach((to, from, next) => {

  if (to.meta.title) {
      document.title = to.meta.title
  }
  // localStorage.setItem('v21406','yes')
  if(localStorage.getItem('v21406')=='yes'){

  }else{
    localStorage.removeItem('token')
    localStorage.removeItem('openid')
  }
  // // 分别为测试环境的openid和token
  // localStorage.setItem('v21105','yes')
  // localStorage.setItem("token", 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImp0aSI6IjE5NzkzIn0.eyJpc3MiOiJ3d3cudW5pb25maXQuY24iLCJhdWQiOiJ3d3cudW5pb25maXQuY24iLCJqdGkiOiIxOTc5MyIsImlhdCI6MTcwNzAyODY1MSwiZXhwIjoxNzM4NTY0NjUxLCJuYmYiOjE3MDcwMjg2NTEsImRhdGEiOiJ7XCJ1c2VyX2lkXCI6MTk3OTMsXCJvcGVuaWRcIjpcIm9XYTJ3dDBUWTFCYTNhUjdMTmtRaGlhRDdMdzBcIixcImRlcGxveV9wcm9maWxlXCI6XCJyZWxlYXNlXCJ9In0.LJYQRWXPECA74lZjZxe7h1ohAo7SNXr3eCXlJoKY1UY')
  // localStorage.setItem("openid", 'oWa2wt0TY1Ba3aR7LNkQhiaD7Lw0')
  // localStorage.setItem('curPosition','{"longitude":121.54409,"latitude":31.22114}')

  // 链接中携带参数
  if (to.query.__source == null || to.query.__source == undefined || to.query.__source == '') {
    // console.log('没有来源参数，不做处理')
  } else {
    localStorage.setItem("source", to.query.__source)
  }

  if (to.query.sharecode == null || to.query.sharecode == undefined || to.query.sharecode == '') {
    // console.log('没有分享参数，不做处理')
  } else {
    localStorage.setItem("sharecode", to.query.sharecode)
  }
  if (to.query.fxcode == null || to.query.fxcode == undefined || to.query.fxcode == '') {
    // console.log('没有分销购买激活码，不做处理')
  } else {
    localStorage.setItem("fxcode", to.query.fxcode)
  }

  // 设置from路由地址
  // localStorage.setItem('prevRouter',from.path)

  let openid = localStorage.getItem("openid");




  if (to.meta.requireAuth) {
    if (to.path == '/author' || to.path == '/login') {
      // console.log('特殊路由，不进行缓存')
    } else {
      localStorage.setItem("routerCur", to.path); //缓存路径，保证获取到openid后，页面能正确跳转
    }

    if (!openid) {
      if (to.path === '/author') {
        next();
      } else {
        getUserCode();
      }
    } else {
      next();
    }
  } else {
    next();
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js